import { api } from "./client";

export interface Environment {
  id: string;
  slug: string;
  name: string;
  type: "production" | "development" | "custom";
  created_at: string;
  /** The caller's effective role in this environment (per-env RBAC). Absent on
   * OSS/self-host (no resolver) → treat as allow-all. */
  role?: "owner" | "admin" | "member" | "viewer";
}

export interface EnvironmentList {
  data: Environment[];
  /** Plan cap on the number of environments (ignore when `unlimited`). */
  limit: number;
  unlimited: boolean;
  /** Whether the plan includes per-environment roles (gates the Team matrix). */
  per_env_roles: boolean;
}

export const environmentsApi = {
  list: () => api<EnvironmentList>("/api/dashboard/environments"),
  create: (name: string) =>
    api<Environment>("/api/dashboard/environments", { method: "POST", body: { name } }),
  rename: (id: string, name: string) =>
    api<Environment>(`/api/dashboard/environments/${id}`, { method: "PATCH", body: { name } }),
  archive: (id: string) =>
    api<{ ok: boolean }>(`/api/dashboard/environments/${id}/archive`, { method: "POST" }),
};
